import { createFileRoute, notFound } from "@tanstack/react-router";
import { buildPageHead } from "@/lib/seo";
import BlogTopic from "@/pages/BlogTopic";

// Guides scoped to one tag; the cross-type view lives at /hub/{tag}.
export const Route = createFileRoute("/guides/topic/$tag")({
  // The library dataset is imported lazily so it stays out of the entry
  // bundle; only the small head fields are returned (they get serialized
  // into the SSR payload).
  loader: async ({ params }) => {
    const { getTag, getPostsByTag } = await import("@/data/library");
    const tag = getTag(params.tag);
    if (!tag) throw notFound();
    // No guides carry this tag — 404 so thin pages never get indexed.
    const posts = getPostsByTag(tag.slug).filter((p) => p.href.startsWith("/guides/"));
    if (posts.length === 0) throw notFound();
    return {
      title: `${tag.name} Guides | Bigdelta`,
      description: tag.blurb,
      slug: tag.slug,
    };
  },
  head: ({ loaderData }) => {
    if (!loaderData) return {};
    return buildPageHead({
      title: loaderData.title,
      description: loaderData.description,
      path: `/guides/topic/${loaderData.slug}`,
    });
  },
  component: () => <BlogTopic scope="guides" />,
});
